import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';


import { I18nPipe, SettingsService, User } from '@delon/theme';
import { LayoutDefaultModule, LayoutDefaultOptions } from '@delon/theme/layout-default';
//import { SettingDrawerModule } from '@delon/theme/setting-drawer';
// import { ThemeBtnComponent } from '@delon/theme/theme-btn';

//import { HeaderClearStorageComponent } from './widgets/clear-storage.component';
//import { HeaderFullScreenComponent } from './widgets/fullscreen.component';
//import { HeaderSearchComponent } from './widgets/search.component';
import { HeaderUserComponent } from './widgets/user.component';
//import { HeaderI18nComponent } from './widgets/i18n.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { HeaderNotifyComponent } from './widgets/notify.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { LoadingService } from 'src/app/share/services/loading.service';
import { debounceTime, Observable, tap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzBreadCrumbModule,
    RouterOutlet,

    //I18nPipe,
    LayoutDefaultModule,
    //SettingDrawerModule,
    //ThemeBtnComponent,

    NzDropDownModule,
    NzAvatarModule,

    //HeaderSearchComponent,
    //HeaderClearStorageComponent,
    //HeaderFullScreenComponent,
    HeaderUserComponent,
    //HeaderI18nComponent,
    HeaderNotifyComponent,
    NzSpinModule,
    CommonModule
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);

  private readonly settings = inject(SettingsService);
  private readonly loadingService = inject(LoadingService);
  loading$: Observable<boolean>;
  constructor() {

  }

  options: any = {
    logoExpanded:'assets/img/logo_white.png',
    logoCollapsed:'assets/img/logo_white.png',
    // logoExpanded: `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjIwMCIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDIwMCAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPGRlZnM+DQogICAgPCEtLSBGb250IHN0eWxlcyAtLT4NCiAgICA8c3R5bGU+DQogICAgICAuZmxvd2VyLXRleHQgew0KICAgICAgICBmb250LWZhbWlseTogJ0FyaWFsJywgc2Fucy1zZXJpZjsNCiAgICAgICAgZm9udC1zaXplOiAxNHB4Ow0KICAgICAgICBmb250LXdlaWdodDogYm9sZDsNCiAgICAgICAgZmlsbDogd2hpdGU7DQogICAgICAgIHRleHQtYW5jaG9yOiBzdGFydDsNCiAgICAgIH0NCiAgICAgIC5sb2dvLXRleHQgew0KICAgICAgICBmb250LWZhbWlseTogJ0FyaWFsJywgc2Fucy1zZXJpZjsNCiAgICAgICAgZm9udC1zaXplOiA4cHg7DQogICAgICAgIGZvbnQtd2VpZ2h0OiBib2xkOw0KICAgICAgICBmaWxsOiB3aGl0ZTsNCiAgICAgICAgdGV4dC1hbmNob3I6IG1pZGRsZTsNCiAgICAgIH0NCiAgICA8L3N0eWxlPg0KICA8L2RlZnM+DQogIA0KICA8IS0tIFNUVCBMb2dvIHdpdGggd2hpdGUgY2lyY2xlIC0tPg0KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LCA4KSI+DQogICAgPCEtLSBXaGl0ZSBjaXJjbGUgYXJvdW5kIFNUVCAtLT4NCiAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxIi8+DQogICAgDQogICAgPCEtLSBTVFQgdGV4dCBjZW50ZXJlZCBpbnNpZGUgY2lyY2xlIC0tPg0KICAgIDx0ZXh0IHg9IjEyIiB5PSIxNSIgY2xhc3M9ImxvZ28tdGV4dCI+U1RUPC90ZXh0Pg0KICA8L2c+DQogIA0KICA8IS0tIFNtYXJ0IFRhdW5nIFRodSBUZXh0IC0tPg0KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNSwgOCkiPg0KICAgIDwhLS0gU21hcnQgLS0+DQogICAgPHRleHQgeD0iMCIgeT0iMTYiIGNsYXNzPSJmbG93ZXItdGV4dCI+U21hcnQ8L3RleHQ+DQogICAgDQogICAgPCEtLSBUYXVuZyAtLT4NCiAgICA8dGV4dCB4PSI1MCIgeT0iMTYiIGNsYXNzPSJmbG93ZXItdGV4dCI+VGF1bmc8L3RleHQ+DQogICAgDQogICAgPCEtLSBUaHUgLS0+DQogICAgPHRleHQgeD0iMTAwIiB5PSIxNiIgY2xhc3M9ImZsb3dlci10ZXh0Ij5UaHU8L3RleHQ+DQogIDwvZz4NCjwvc3ZnPiA=`,//data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjM2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMzYiIGZpbGw9InRyYW5zcGFyZW50Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIyNCIgZmlsbD0id2hpdGUiPlNtYXJ0IFRhdW5nIFRodTwvdGV4dD48L3N2Zz4=
    // logoCollapsed: `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgMzYgMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxkZWZzPg0KICAgIDwhLS0gRm9udCBzdHlsZSBmb3IgU1RUIC0tPg0KICAgIDxzdHlsZT4NCiAgICAgIC5sb2dvLXRleHQgew0KICAgICAgICBmb250LWZhbWlseTogJ0FyaWFsJywgc2Fucy1zZXJpZjsNCiAgICAgICAgZm9udC1zaXplOiAxMHB4Ow0KICAgICAgICBmb250LXdlaWdodDogYm9sZDsNCiAgICAgICAgZmlsbDogd2hpdGU7DQogICAgICAgIHRleHQtYW5jaG9yOiBtaWRkbGU7DQogICAgICB9DQogICAgPC9zdHlsZT4NCiAgPC9kZWZzPg0KICANCiAgPCEtLSBTVFQgTG9nbyB3aXRoIHdoaXRlIGNpcmNsZSAtLT4NCiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMywgMykiPg0KICAgIDwhLS0gV2hpdGUgY2lyY2xlIGFyb3VuZCBTVFQgLS0+DQogICAgPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPg0KICAgIA0KICAgIDwhLS0gU1RUIHRleHQgY2VudGVyZWQgaW5zaWRlIGNpcmNsZSAtLT4NCiAgICA8dGV4dCB4PSIxNSIgeT0iMTkiIGNsYXNzPSJsb2dvLXRleHQiPlNUVDwvdGV4dD4NCiAgPC9nPg0KPC9zdmc+IA==`,
    sider: {
      collapsible: true,
      defaultCollapsed: false, // Prevent auto-collapse
    },
  };
  searchToggleStatus = false;
  showSettingDrawer = false;
  get user(): User {
    return this.settings.user;
  }

  ngOnInit() {
    this.loading$ = this.loadingService.loading$.pipe(
      debounceTime(101),
      tap(() => this.cdr.detectChanges())
    );
  }
}
